import axios from "axios";

export const PERSONNEL_URL = "/Personnel";
export const PERSONNEL_TYPE_URL = "/PersonnelType";

/** Belli Bir Personel Listesini Elde Eder */
export function getPersonnels(queryParams) {
  return axios.post(`${PERSONNEL_URL}/GetPersonnels`, queryParams);
}

/** Belli Bir Personel Listesini Sayfalama Olmadan Elde Eder */
export function getAllPersonnels(queryParams) {
  return axios.post(`${PERSONNEL_URL}/GetAllPersonnels`, queryParams);
}

/** Mevcut Okulun Personel Türü Listesini Elde Eder */
export function getPersonnelTypes() {
  return axios.get(`${PERSONNEL_TYPE_URL}/GetPersonnelTypes`);
}

/** Yeni Bir Personel Elde Eder */
export function getNewPersonnel() {
  return axios.get(PERSONNEL_URL);
}

/** Belli Bir Personeli Elde Eder */
export function getPersonnel(id) {
  return axios.get(`${PERSONNEL_URL}/${id}`);
}

/** Belli Bir Personeli Kaydeder */
export function savePersonnel(personnel) {
  return axios.post(PERSONNEL_URL, personnel);
}

/** Belli Bir Personel Listesinin Sözleşmelerini Mevcut Dönem İçin Yeniler */
export function renewContracts(ids) {
  return axios.post(`${PERSONNEL_URL}/RenewContracts`, { ids });
}

/** Belli Bir Personel Listesini Siler */
export function deletePersonnels(ids) {
  return axios.post(`${PERSONNEL_URL}/Delete`, { ids });
}

/** Belli Bir Personel Listesinin Belli Bir Dönemdeki Sözleşmelerini Siler */
export function deleteContracts(term, ids) {
  return axios.post(`${PERSONNEL_URL}/DeleteContracts`, { term, ids });
}